import { Injectable } from '@angular/core';
import { CompanyAccount } from '@app/shared/models/company-account.model';
import { Adapter } from '../adapter';
import { DEFAULT_DOMAINS, DEFAULT_PRODUCTION_DOMAIN } from '@core/constants/white-label';

@Injectable()
export class CompanyAccountAdapter implements Adapter<CompanyAccount> {
    adapt(data: any): CompanyAccount {
        const account = new CompanyAccount();
        const domain = DEFAULT_DOMAINS.includes(data.companyDomain || DEFAULT_PRODUCTION_DOMAIN)
            ? DEFAULT_PRODUCTION_DOMAIN
            : data.companyDomain;

        account.dashboards = data.Dashboards || [];
        account.role = data.role || '';
        account.type = data.companyType || '';
        account.name = data.companyName || '';
        account.id = data.companyId || 0;
        account.rawValue = data.rawValue || '';
        account.domain = domain;
        return account;
    }
}
